import React, { useState } from "react";
import { envoyerEmailOuVerification } from "./VerifierEmail";
import "../css/ModalMessageSupport.css";


export const ModalMessageSupport = ({
  ouvrir,
  setOuvrir,
}) => {
  const [userEmail, setUserEmail] = useState("");
  const [contenu, setContenu] = useState("");
  const [messageEnvoye, setMessageEnvoye] = useState(false);

  if (!ouvrir) return null;

  const handleEnvoyer = () => {
    envoyerEmailOuVerification(userEmail, contenu, "message");
    setMessageEnvoye(true);
    setTimeout(() => {
      setOuvrir(false);
      setMessageEnvoye(false);
      setUserEmail("");
      setContenu("");
    }, 3000);
  };

  return (
    <div className="modal-message-support-overlay">
    <div className="modal-message-support-container">
      {messageEnvoye ? (
        <h2 className="modal-message-support-titre">Merci ! Votre message a bien été envoyé.</h2>
      ) : (
        <>
          <h2 className="modal-message-support-titre">Envoyer un message au support</h2>
          <input
            type="email"
            placeholder="Votre adresse email"
            value={userEmail}
            onChange={(e) => setUserEmail(e.target.value)}
            className="modal-message-support-input"
          />
          <textarea
            placeholder="Décrivez votre problème..."
            value={contenu}
            onChange={(e) => setContenu(e.target.value)}
            className="modal-message-support-textarea"
          ></textarea>
          <div className="modal-message-support-boutons">
            <button
              className="modal-message-support-bouton cancel"
              onClick={() => setOuvrir(false)}
            >
              Annuler
            </button>
            <button
              className="modal-message-support-bouton submit"
              onClick={handleEnvoyer}
            >
              Envoyer
            </button>
          </div>
        </>
      )}
    </div>
  </div>
  );
};

export default ModalMessageSupport;
